import React from 'react';
import Logo from '../Logo/Logo.js';
import CreateChat from '../CreateChat/CreateChat.js'
import ChatHistory from '../ChatHistory/ChatHistory.js';
import Authentication from '../Authentication/Authentication.js';
import styles from './SideBar.module.css';
import { useSelector } from 'react-redux';

function SideBar() {
  const chats = useSelector((state) => state.chat.chats);

  return (
    <div className={styles.layout}>
      <Logo />
      <CreateChat />
      <ChatHistory chats={chats}/>
      <Authentication />
    </div>    
  );
}

export default SideBar;